import { Component } from '@angular/core';

@Component({
  selector: 'app-components-managecustomer-googlecustomeraccounts',
  templateUrl: './google-customer-accounts.component.html'
})
export class GoogleCustomerAccountsComponent implements IActivatable {
  customer: CustomerObservable;
  customerId: number;
  customerAccountTypes: number[];
  showSaveButton: boolean;
  publicApiCallback: any;
  isEnabled: KnockoutObservable<boolean>;

  canActivate(_user: Boo.Objects.User, _partner: Boo.Objects.Partner, params: IGoogleCustomerAccountParams): boolean {
    this.customer = params.customer;
    this.customerId = params.customerId;
    this.customerAccountTypes = params.customerAccountTypes;
    this.showSaveButton = params.showSaveButton;
    this.isEnabled = params.isEnabled;
    this.publicApiCallback = params.publicApiCallback;
    return true;
  }
}

interface IGoogleCustomerAccountParams {
  customer: CustomerObservable;
  customerId: number;
  customerAccountTypes: number[];
  showSaveButton: boolean;
  publicApiCallback: any;
  isEnabled: KnockoutObservable<boolean>;
}
